import type { Locale } from "@/i18n/locales";

import { platforms as enPlatforms, search as enSearch } from "./en/platforms";
import { platforms as dePlatforms, search as deSearch } from "./de/platforms";
import type { PlatformsContent, SearchContent } from "./types";

const PLATFORMS: Readonly<Record<Locale, PlatformsContent>> = {
  en: enPlatforms,
  de: dePlatforms,
};
const SEARCH: Readonly<Record<Locale, SearchContent>> = { en: enSearch, de: deSearch };

export function platformsFor(locale: Locale): PlatformsContent {
  return PLATFORMS[locale];
}

export function searchFor(locale: Locale): SearchContent {
  return SEARCH[locale];
}
